import React from 'react'
import styled from 'styled-components'

import { ASSET_URL } from '../../../constants/ApiEndpoints'
import { logEvent } from '../../../utils/firebase'

const tabs = [
  {
    label: 'Living',
    value: '17006',
    url: ASSET_URL + 'designer/tabs/living.jpg'
  },
  {
    label: 'Dining',
    value: '18243',
    url: ASSET_URL + 'designer/tabs/dining.jpg'
  },
  {
    label: 'Office',
    value: '16566',
    url: ASSET_URL + 'designer/tabs/office.jpg'
  },
  {
    label: 'Bedroom',
    value: '16703',
    url: ASSET_URL + 'designer/tabs/bedroom.jpg'
  },
  {
    label: 'Bathroom',
    value: '10011',
    url: '/assets/templatetabs/bathroom.jpg'
  },
  {
    label: 'Outdoor',
    value: '10000',
    url: ASSET_URL + 'designer/tabs/outdoor.jpg'
  },
  {
    label: 'Kids',
    value: '10003',
    url: ASSET_URL + 'designer/tabs/kidsroom.jpg'
  },
  {
    label: 'Mood',
    value: 'moodboard',
    url: '/assets/templatetabs/mood.jpg'
  },
  {
    label: 'Others',
    value: 'others',
    url: '/assets/templatetabs/others.jpg'
  }
]

const Container = styled.div`
  display: flex;
  gap: 8px;
  margin-bottom: 20px;
  padding: 0 8px;
  padding-left: 10px;
  overflow-y: auto;

  &::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none;
  scrollbar-width: none;

  @media (max-width: 800px) {
    overflow: auto;
  }
`

const SpacerContainer = styled.div`
  width: 100%;
  display: flex;
`

const TabContainer = styled.div`
  display: inline-block;
  position: relative;
  border-radius: 10px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  background-color: ${props => props.theme.redacted};

  width: 100%;
  min-width: 100px;
  cursor: pointer;
  overflow: hidden;

  height: 40px;

  @media only screen and (min-width: 768px) {
    height: 50px;
  }

  @media only screen and (min-width: 992px) {
    height: 80px;
  }

  @media only screen and (max-width: 768px) {
    width: 82px;
    height: 56px;
  }
`

const TitleContainer = styled.div`
  position: absolute;
  right: 10px;
  bottom: 5px;
  font-weight: bold;
  font-size: 14px;
  color: white;
  text-shadow: 0px 2px 4px rgba(0, 0, 0, 0.5);
  z-index: 3;

  @media only screen and (min-width: 992px) {
    font-size: 14px;
  }

  @media only screen and (min-width: 992px) {
    font-size: 20px;
  }
`

const Overlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 2;
  background-color: ${props => (props.active === true ? 'white' : 'black')};
  opacity: ${props => (props.active === true ? '0.4' : '0.5')};
  transition-property: opacity;
  transition-duration: 0.2s;
  transition-timing-function: ease;
  border-radius: 10px;

  &:hover {
    opacity: 0;
  }
`

const Tab = ({ data, selected, onSelect }) => {
  const handleClick = e => {
    logEvent('template_filter', {
      content_type: 'template',
      content_id: data.value
    })

    if (onSelect) onSelect(data)
  }

  return (
    <SpacerContainer>
      <TabContainer
        style={{ backgroundImage: `url(${data.url})` }}
        onClick={handleClick}
      >
        <Overlay active={selected === data.value ? true : false} />
        <TitleContainer>{data.label}</TitleContainer>
      </TabContainer>
    </SpacerContainer>
  )
}

const TemplateTabs = ({ selected, onSelect }) => {
  return (
    <Container>
      {tabs.map((d, i) => (
        <Tab
          data={d}
          key={'tab_' + i}
          index={i}
          selected={selected}
          onSelect={onSelect}
        />
      ))}
    </Container>
  )
}

export default TemplateTabs
